export default __webpack_public_path__ + "static/media/topographic.ed0d62e9.svg";